module.exports = __webpack_public_path__ + "static/image-matching-737226c596d285804ce777440af2c901.svg";